export const services = [
  {
    img: "ser_img_one.webp",
    title: "Generative AI",
    desc: "Tap into the limitless creativity of generative AI, revolutionizing industries such as art, entertainment, and advertising by generating authentic and innovative content, artwork, and designs",
  },
  {
    img: "ser_img_two.webp",
    title: "AI Chatbot",
    desc: "Enjoy the convenience of a seamless AI chatbot that understands and meets your needs, from scheduling tasks and answering queries to delivering personalized recommendations",
  },
  {
    img: "ser_img_three.webp",
    title: "AI product development",
    desc: "Realize your vision with our AI product development services. We leverage advanced algorithms and cutting-edge technologies to build intelligent and innovative solutions tailored to your business.",
  },
  {
    img: "ser_img_four.webp",
    title: "Recommendation Engine",
    desc: "Elevate customer experiences and engagement with a powerful recommendation engine that analyzes user preferences and behaviors, delivering personalized recommendations that boost conversions and satisfaction.",
  },
  {
    img: "ser_img_five.webp",
    title: "AI Security",
    desc: "Safeguard your valuable data and systems using AI-powered security solutions. With advanced algorithms and machine learning, threats are detected and mitigated in real-time, ensuring robust protection against cyber threats.",
  },
  {
    img: "ser_img_six.webp",
    title: "AI design",
    desc: "Transform design processes with AI-driven tools that automate tasks, generate design options, and enhance creativity, empowering designers to deliver stunning visuals and exceptional user experiences.",
  },
  {
    img: "ser_img_seven.webp",
    title: "AIOPs",
    desc: "Streamline IT operations with AIOPs solutions that utilize artificial intelligence and machine learning. Automate tasks, optimize resources, and proactively identify and resolve issues for high system availability and performance.",
  },
  {
    img: "ser_img_eight.webp",
    title: "AIaaS",
    desc: "Harness the power of AI as a service (AIaas) to access advanced capabilities without the need for extensive infrastructure or expertise. Accelerate the integration of AI into your applications and systems.",
  },
  {
    img: "ser_img_nine.webp",
    title: "Automation solutions",
    desc: "Enhance efficiency and productivity with intelligent automation solutions. Leveraging AI and machine learning, automate repetitive tasks, streamline workflows, and achieve operational excellence.",
  },
  {
    img: "ser_img_ten.webp",
    title: "Predictive modelling",
    desc: "Unlock valuable insights and make informed decisions through predictive modeling. Utilize AI and statistical techniques to analyse data patterns, forecast trends, and optimize outcomes, keeping your business ahead of the curve.",
  },
];

export const stepsData = [
  {
    id: "step-one",
    title: "01",
    description: "Healthcare",
    content: {
      title: "Healthcare",
      text: "Revolutionizing healthcare, AI technologies enhance diagnostics, personalized treatment plans, and patient care, improving outcomes and cost efficiency",
    },
    imageSrc: require("../../../image/Aidevelop/step-one.webp"),
  },
  {
    id: "step-two",
    title: "02",
    description: "Finance",
    content: {
      title: "Finance",
      text: "In finance, AI transform operations, automate risk assessment, detect fraud, and deliver personalized financial services.",
    },
    imageSrc: require("../../../image/Aidevelop/step-two.webp"),
  },
  {
    id: "step-three",
    title: "03",
    description: "Education",
    content: {
      title: "Education",
      text: "Unlocking potential in education, AI personalize learning experiences, enable adaptive tutoring, and leverage data analytics for insights and improvements.",
    },
    imageSrc: require("../../../image/Aidevelop/step-three.webp"),
  },
  {
    id: "step-four",
    title: "04",
    description: "Logistics",
    content: {
      title: "Logistics",
      text: "Embrace AI for automation solutions, increasing productivity, streamlining workflows, and achieving operational excellence across industries.",
    },
    imageSrc: require("../../../image/Aidevelop/step-four.webp"),
  },
  {
    id: "step-five",
    title: "05",
    description: "Automation",
    content: {
      title: "Automation",
      text: "Strengthen cybersecurity with AI, detecting anomalies, preventing attacks, and safeguarding sensitive data through advanced threat intelligence and proactive defense mechanisms.",
    },
    imageSrc: require("../../../image/Aidevelop/step-five.webp"),
  },
  {
    id: "step-six",
    title: "06",
    description: "Cyber security",
    content: {
      title: "Cyber security",
      text: "Strengthen cybersecurity with AI, detecting anomalies, preventing attacks, and safeguarding sensitive data through advanced threat intelligence and proactive defense mechanisms.",
    },
    imageSrc: require("../../../image/Aidevelop/step-six.webp"),
  },
  {
    id: "step-seven",
    title: "07",
    description: "Aviation",
    content: {
      title: "Aviation",
      text: "Revolutionize the aviation industry with AI, enhancing flight operations, optimizing maintenance, improving safety measures, and enabling predictive analytics for better decision-making.",
    },
    imageSrc: require("../../../image/Aidevelop/step-seven.webp"),
  },
  {
    id: "step-eight",
    title: "08",
    description: "Research & development",
    content: {
      title: "Research & development",
      text: "Fuel innovation in research & development with AI & ML, accelerating data analysis, facilitating drug discovery, and enabling breakthrough advancements in scientific domains.",
    },
    imageSrc: require("../../../image/Aidevelop/step-eight.webp"),
  },
  {
    id: "step-nine",
    title: "09",
    description: "Agriculture",
    content: {
      title: "Agriculture",
      text: "Drive agricultural efficiency with AI, optimizing crop yield, monitoring soil conditions, automating irrigation, and enabling precision farming for sustainable practices.",
    },
    imageSrc: require("../../../image/Aidevelop/step-nine.webp"),
  },
  {
    id: "step-ten",
    title: "10",
    description: "E-commerce",
    content: {
      title: "Ecommerce",
      text: "Enhance customer experiences in e-commerce with AI, personalizing recommendations, optimizing inventory management, automating customer support, and delivering targeted marketing campaigns.",
    },
    imageSrc: require("../../../image/Aidevelop/step-ten.webp"),
  },
];
